var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isFullWidth
    ? _c(
        "div",
        {
          staticClass: "fixed-grid has-12-cols is-align-self-center",
          on: { click: (event) => _vm.$emit("handleClick", event) },
        },
        [
          _c("div", { staticClass: "grid is-align-items-center" }, [
            _c("div", { staticClass: "cell is-col-span-6" }, [
              _c("div", { staticClass: "fixed-grid has-12-cols" }, [
                _c("div", { staticClass: "grid is-align-items-center" }, [
                  _c(
                    "div",
                    {
                      staticClass: "cell is-flex is-flex-direction-column",
                      class: _vm.isPaintItem
                        ? "is-col-span-8"
                        : _vm.showPaintLoading
                        ? "is-col-span-9"
                        : "is-col-span-11",
                    },
                    [_vm._t("description")],
                    2
                  ),
                  _vm.isPaintItem
                    ? _c(
                        "div",
                        { staticClass: "cell center is-col-span-2" },
                        [_vm._t("paint_group")],
                        2
                      )
                    : _vm._e(),
                  _vm.isPaintItem
                    ? _c(
                        "div",
                        { staticClass: "cell is-col-span-1 is-clickable" },
                        [_vm._t("blend")],
                        2
                      )
                    : _vm._e(),
                  _vm.showPaintLoading
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "cell is-col-span-2 is-flex is-align-items-center is-justify-content-center",
                        },
                        [_vm._t("loading")],
                        2
                      )
                    : _vm._e(),
                  _c(
                    "div",
                    { staticClass: "cell is-col-span-1 is-clickable" },
                    [_vm._t("report")],
                    2
                  ),
                ]),
              ]),
            ]),
            _c(
              "div",
              { staticClass: "cell" },
              [_vm.isQuoteHour ? _vm._t("rates") : _vm._e()],
              2
            ),
            _c("div", { staticClass: "cell" }, [_vm._t("hour_value")], 2),
            _c("div", { staticClass: "cell is-col-span-2" }, [
              _c("div", { staticClass: "fixed-grid has-12-cols" }, [
                _c("div", { staticClass: "grid" }, [
                  _c("div", { staticClass: "cell is-col-span-6" }),
                  _c(
                    "div",
                    { staticClass: "cell is-col-span-6" },
                    [_vm._t("present_as")],
                    2
                  ),
                ]),
              ]),
            ]),
            _c(
              "div",
              { staticClass: "cell is-col-span-1" },
              [_vm._t("total_value")],
              2
            ),
            _c("div", { staticClass: "cell end is-align-items-center" }, [
              _c(
                "div",
                { staticClass: "mt-1 is-flex" },
                [
                  _vm._t("comment"),
                  _vm._t("assessment_status"),
                  _vm._t("delete"),
                  _vm._t("draggable"),
                ],
                2
              ),
            ]),
          ]),
        ]
      )
    : _c(
        "div",
        {
          staticClass: "fixed-grid has-12-cols is-align-self-center",
          on: { click: (event) => _vm.$emit("handleClick", event) },
        },
        [
          _c(
            "div",
            {
              staticClass: "grid is-align-self-center is-align-items-center",
              staticStyle: { "row-gap": "5px" },
            },
            [
              _c(
                "div",
                {
                  staticClass: "cell is-align-content-center",
                  class:
                    _vm.isPaintItem || _vm.showPaintLoading
                      ? "is-col-span-4"
                      : "is-col-span-5",
                },
                [_vm._t("description")],
                2
              ),
              _vm.isPaintItem
                ? _c(
                    "div",
                    {
                      staticClass:
                        "cell is-col-span-1 is-flex is-align-items-center is-justify-content-center",
                    },
                    [_vm._t("blend")],
                    2
                  )
                : _vm._e(),
              _vm.showPaintLoading
                ? _c(
                    "div",
                    {
                      staticClass:
                        "cell is-col-span-1 is-flex is-align-items-center is-justify-content-center",
                    },
                    [_vm._t("loading")],
                    2
                  )
                : _vm._e(),
              _c(
                "div",
                {
                  staticClass:
                    "cell is-col-span-1 is-flex is-align-items-center is-justify-content-center",
                },
                [_vm._t("report")],
                2
              ),
              _c(
                "div",
                { staticClass: "cell is-col-span-2 is-align-content-center" },
                [
                  _c("div", { staticClass: "fixed-grid has-12-cols" }, [
                    _c("div", { staticClass: "grid is-align-items-center" }, [
                      _c(
                        "div",
                        { staticClass: "cell is-col-span-6" },
                        [_vm.isQuoteHour ? _vm._t("rates") : _vm._e()],
                        2
                      ),
                      _c(
                        "div",
                        { staticClass: "cell is-col-span-6" },
                        [_vm._t("hour_value")],
                        2
                      ),
                    ]),
                  ]),
                ]
              ),
              _c(
                "div",
                { staticClass: "cell is-col-span-4 is-align-content-center" },
                [
                  _c("div", { staticClass: "fixed-grid has-12-cols" }, [
                    _c("div", { staticClass: "grid is-align-items-center" }, [
                      _c(
                        "div",
                        { staticClass: "cell is-col-span-5" },
                        [_vm._t("total_value")],
                        2
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "cell is-col-span-7 end is-align-items-center",
                        },
                        [
                          _vm._t("comment"),
                          _vm._t("assessment_status"),
                          _vm._t("delete"),
                          _vm._t("draggable"),
                        ],
                        2
                      ),
                    ]),
                  ]),
                ]
              ),
              _vm.isFullyExpanded && _vm.isSupportUser
                ? _c(
                    "div",
                    { staticClass: "cell is-col-span-2" },
                    [_vm._t("lineNo")],
                    2
                  )
                : _vm._e(),
              _vm.isFullyExpanded && _vm.isSupportUser
                ? _c(
                    "div",
                    { staticClass: "cell is-col-span-2" },
                    [_vm._t("itemNo")],
                    2
                  )
                : _vm._e(),
              _vm.isFullyExpanded && _vm.isSupportUser
                ? _c(
                    "div",
                    { staticClass: "cell is-col-span-1" },
                    [_vm._t("itemStatus")],
                    2
                  )
                : _vm._e(),
              _vm.isFullyExpanded
                ? _c(
                    "div",
                    { staticClass: "cell is-col-span-2 mt-2" },
                    [_vm._t("present_as")],
                    2
                  )
                : _vm._e(),
              _vm.isFullyExpanded && !_vm.isSupportUser
                ? _c("div", { staticClass: "cell is-col-span-5" })
                : _vm._e(),
              _vm.isFullyExpanded && _vm.isPaintItem
                ? _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "tippy",
                          rawName: "v-tippy",
                          value: { content: "Paint Group" },
                          expression: "{ content: 'Paint Group'}",
                        },
                      ],
                      staticClass: "cell is-col-span-2",
                    },
                    [_vm._t("paint_group")],
                    2
                  )
                : _vm.isFullyExpanded
                ? _c("div", { staticClass: "cell is-col-span-2" })
                : _vm._e(),
              _vm.isFullyExpanded
                ? _c("div", { staticClass: "cell is-col-span-3" })
                : _vm._e(),
            ]
          ),
        ]
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }